<template>
    <div class="relative">
        <button
            class="flex items-center space-x-2 rounded-md px-3 py-2 text-sm font-medium text-white hover:bg-gray-700 focus:outline-hidden focus:ring-2 focus:ring-indigo-500"
            @click="isOpen = !isOpen"
        >
            <span class="text-lg">{{ getCurrentLanguageFlag() }}</span>
            <span>{{ getCurrentLanguageName() }}</span>
            <svg
                class="h-4 w-4 transition-transform"
                :class="{ 'rotate-180': isOpen }"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </button>

        <div
            v-if="isOpen"
            v-click-away="closeDropdown"
            class="absolute right-0 top-full z-50 mt-2 w-48 rounded-md bg-gray-800 py-1 shadow-lg ring-1 ring-gray-600"
        >
            <a
                v-for="language in availableLanguages"
                :key="language.code"
                :href="`/language/${language.code}`"
                class="flex items-center space-x-3 px-4 py-2 text-sm text-gray-200 hover:bg-gray-700"
                @click="isOpen = false"
            >
                <span class="text-lg">{{ language.flag }}</span>
                <span>{{ language.name }}</span>
            </a>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { usePage } from "@inertiajs/vue3";

const isOpen = ref(false);

const availableLanguages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "cs", name: "Čeština", flag: "🇨🇿" },
];

const page = usePage();
const currentLocale = computed(() => page.props.locale || "en");

const getCurrentLanguageFlag = () => {
    const language = availableLanguages.find(
        (lang) => lang.code === currentLocale.value,
    );
    return language?.flag || "🇺🇸";
};

const getCurrentLanguageName = () => {
    const language = availableLanguages.find(
        (lang) => lang.code === currentLocale.value,
    );
    return language?.name || "English";
};

const closeDropdown = () => {
    isOpen.value = false;
};
</script>
